import React, { useEffect, useRef, useContext } from "react"
import { StateContext } from "./provider"
import Transition from "../transition"
import { twMerge } from "tailwind-merge"
import { Index, useInstantSearch } from "react-instantsearch"
import CustomProductHits from "../el/searchhitproduct"
import CustomResourceHits from "../el/searchhitresources"
import { CustomStats, H2 } from "../el/searchelements"

// wrapper for hits
const CustomResults = () => {
  const { results } = useInstantSearch()
  const { stateSearch } = useContext(StateContext)
  const [searchOpen, setSearchOpen] = stateSearch
  const node = useRef()
  useEffect(() => {
    const isQuery =
      results.query === undefined || results.query === "" ? false : true
    setSearchOpen(isQuery)
  }, [results.query, setSearchOpen])

  useEffect(() => {
    const handleClickOutside = e => {
      if (node.current.contains(e.target)) {
        return
      }
      setSearchOpen(!searchOpen)
    }
    if (searchOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [searchOpen, setSearchOpen])

  return (
    <Transition
      show={searchOpen}
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 translate-y-1"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-1"
    >
      <div
        ref={node}
        className="absolute -left-1/4 mt-6 w-screen max-w-lg px-2 sm:left-0 sm:px-0 lg:left-auto lg:right-0 xl:-right-1/4"
      >
        <div className="rounded-lg bg-white shadow-lg">
          <div
            className={twMerge([
              "resultsWrapper",
              "overflow-hidden overflow-y-scroll rounded-lg ring-1 ring-black ring-opacity-5",
            ])}
          >
            <div className="relative z-20 px-4 pb-5">
              {/* Hits go here */}
              <Index indexName="dev_PRODUCTS">
                <H2 text="Products">
                  <CustomStats />
                </H2>
                <CustomProductHits />
              </Index>
              <Index indexName="RESOURCES">
                <H2 className="mt-4" text="Technical Resources">
                  <CustomStats />
                </H2>
                <CustomResourceHits />
              </Index>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  )
}

//sylted components

export default CustomResults
